import httpbaseURL from "../common/axios";
class Commonservices {
  List() {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get("/ApprovalHistory/List");
  }

  GetListApprovalHistoryByDeptRoleId(DeptRoleId, EntityId, OrganizationId) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/ApprovalHistory/ListApprovalHistoryByDeptRoleId?DeptRoleId=" +
        DeptRoleId +
        "&EntityId=" +
        EntityId +
        "&OrganizationId=" +
        OrganizationId +
        ""
    );
  }
  GetListByDeptRoleId(DeptRoleId) {
    debugger;
    return httpbaseURL.httpMSUserManageMentUrl.get(
      "/ApprovalHistory/ApprovalHistoryByDeptRoleIdHeader?DeptRoleId=" +
        DeptRoleId
    );
  }
}
export default new Commonservices();
